<template>
  <aside class="how-work-content margin-general mt-4">
    <h3 class="body-3-bold">
      {{ $t("calculator-suite.howitworks.followSteps") }}
    </h3>
    <div class="card-box">
      <div class="card" v-for="(step, index) in returnSteps" :key="step.icon">
        <div class="card-header">
          <div class="box-img">
            <span class="material-symbols-outlined body-3" translate="no">
              {{ step.icon }}
            </span>
          </div>
          <span class="number">{{ index + 1 }}.</span>
        </div>
        <div class="card-body">
          <p class="caption">{{ $t(step.description) }}</p>
        </div>
      </div>
    </div>
  </aside>
</template>
<script setup>
import { defineEmits, defineProps, computed } from "vue";

const emit = defineEmits();
const props = defineProps(["activeTab"]);
const lotsteps = [
  {
    icon: "variable_insert",
    description: "calculator-suite.howitworks.step1",
  },
  {
    icon: "attach_money",
    description: "calculator-suite.howitworks.step2",
  },
  { icon: "123", description: "calculator-suite.howitworks.step3" },
  { icon: "calculate", description: "calculator-suite.howitworks.step4" },
];
const mastersteps = [
  {
    icon: "variable_insert",
    description: "calculator-suite.howitworks.masterStep1",
  },
  {
    icon: "attach_money",
    description: "calculator-suite.howitworks.masterStep2",
  },
  { icon: "123", description: "calculator-suite.howitworks.masterStep3" },
  { icon: "calculate", description: "calculator-suite.howitworks.masterStep4" },
];
const currencysteps = [
  {
    icon: "variable_insert",
    description: "calculator-suite.howitworks.currencyStep1",
  },
  {
    icon: "attach_money",
    description: "calculator-suite.howitworks.currencyStep2",
  },
  { icon: "euro", description: "calculator-suite.howitworks.currencyStep3" },
  {
    icon: "calculate",
    description: "calculator-suite.howitworks.currencyStep4",
  },
];
const fibonaccisteps = [
  {
    icon: "variable_insert",
    description: "calculator-suite.howitworks.fibonacciStep1",
  },
  {
    icon: "attach_money",
    description: "calculator-suite.howitworks.fibonacciStep2",
  },
  { icon: "euro", description: "calculator-suite.howitworks.fibonacciStep3" },
  {
    icon: "calculate",
    description: "calculator-suite.howitworks.currencyStep4",
  },
];
const pivotsteps = [
  {
    icon: "variable_insert",
    description: "calculator-suite.howitworks.pivotStep1",
  },
  {
    icon: "contract_edit",
    description: "calculator-suite.howitworks.pivotStep2",
  },
  {
    icon: "calculate",
    description: "calculator-suite.howitworks.currencyStep4",
  },
];

const returnSteps = computed(() => {
  const defaultVal = props.activeTab ?? "lot";
  if (defaultVal.includes("lot")) return lotsteps;
  if (defaultVal.includes("master")) return mastersteps;
  if (defaultVal.includes("currency")) return currencysteps;
  if (defaultVal.includes("fibonacci")) return fibonaccisteps;
  if (defaultVal.includes("pivot")) return pivotsteps;
});
</script>
